import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const hh = Math.floor(seconds / 3600);
  const mm = Math.floor(seconds % 3600 / 60);
  const ss = seconds % 60;
  return {
    hh,
    mm,
    ss
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="relative z-10 flex flex-col items-center" data-id="element-32" data-mp="3h20gp93lchj0">
      <div className="animate-pulse-red flex h-16 w-16 items-center justify-center rounded-xl border border-red-500/40 font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-33" data-mp="323q1tbg34yso">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-34" data-mp="10cv3ocyeonis">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 47);
  return <section aria-label="Cuenta regresiva" className="relative w-full overflow-x-hidden bg-ink" data-id="element-35" data-mp="t2d3x7nkpwls">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center pt-[28px] pb-[0px]" style={{
      paddingTop: "14px",
      paddingBottom: "18px"
    }} data-id="element-36" data-mp="17qq4khxlw3mm">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" style={{
        paddingTop: "5px",
        marginTop: "-5px",
        marginBottom: "-5px"
      }} data-id="element-37" data-mp="12t7swjs7faax">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="relative mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-38" data-mp="a5c03q5ra2jf">
          <div className="animate-glow-red pointer-events-none absolute inset-y-[-25%] left-1/2 w-[min(16rem,80%)] -translate-x-1/2 rounded-full bg-red-600/40 blur-2xl" aria-hidden="true" data-id="element-39" data-mp="o4boqxt9qhfl" />
          <Unit value={hh} label="Horas" data-id="element-40" data-mp="1zgktidhjxrar" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="1vgkg8w66vm5a">:</span>
          <Unit value={mm} label="Min" data-id="element-42" data-mp="1viww93sdzmfp" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-43" data-mp="s6g3jap6l3gl">:</span>
          <Unit value={ss} label="Seg" data-id="element-44" data-mp="x4hlttes8yr0" />
        </div>
        <p className="mt-6 text-sm font-semibold text-white/60" style={{
        paddingTop: "14px",
        marginTop: "-2px",
        marginBottom: "-2px"
      }} data-id="element-45" data-mp="x2wqi1kn9bs3">
          ⚠️ Después sube $35.000 ARS. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-8 max-w-md" style={{
        paddingTop: "7px",
        paddingBottom: "5px",
        marginTop: "-5px",
        marginBottom: "-5px"
      }} data-id="element-46" data-mp="9f5ekz30n0rc">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-47" data-mp="eerrf7exmezm">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-48" data-mp="ie0niixg2oyc">
            <div className="h-full w-[68%] rounded-full bg-verde" style={{
            backgroundColor: "#85272F"
          }} data-id="element-49" data-mp="n8obmgojdhce" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-gold" data-id="element-50" data-mp="3qvn8q7itwakr">
            68% tomados — Quedan pocos
          </p>
        </div>
      </div>
    </section>;
}